import { atom } from "recoil"
import { IWorkspaceListItem } from "../model/Workspace"

export const recreateState = atom<IWorkspaceListItem|null>({
  key: 'recreateState',
  default: null,
})